module.exports = __webpack_public_path__ + "static/media/mfm_logo.56fd4eb8.png";